var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3cmb9df50a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360 0v640H0V0h360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tlpmxe4krb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.32 12.8v2.56H0V12.8h24.32zm0-6.4v2.56H0V6.4h24.32zm0-6.4v2.56H0V0h24.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "koecry0tqc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6 0v34H0V0h33.6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3cmb9df50a)",
    transform: "translate(-20 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tlpmxe4krb)",
    transform: "translate(23.84 22.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.32v15.36H0V0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#koecry0tqc)",
    transform: "translate(-3.84 -8.96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.84 8.96h24.32v15.36H3.84V8.96z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.82ecf807b6759948fbbfe01190658e43.svg";
export { ForwardRef as ReactComponent };